import React from 'react';
import chevronDoublePurple from './images/chevron-double-purple.svg';
import arrow from './images/btn-arrows.svg';
const BtnRightSideText = (props) => {

  var backGroundImage = props.isGreyBg ? chevronDoublePurple.bg() : arrow.bg();
  return (
    <button id='btnRightText' type='submit' className={`${props.isMobile? 'isMobile': ''} btn-right-text ${props.isBusiness ? ' purple' : ''} ${props.isGreyBg ? 'grey-bg':''} ${props.customClass ? props.customClass : '' }`} form={props.formid} onClick={props.onclick}>
      <span htmlFor='btnRightText' className='btn-right-text__label'>
        {props.text}
      </span>
      { props.isDisplayArrows && <span className="arrows-icon" style={{backgroundImage:backGroundImage}} ></span> }      
    </button>
  );
};

export default BtnRightSideText;